<template>
	<v-app id="inspire">
		<v-app-bar clipped-left flat app>
			<v-img src="/Sieloggaröd för brevpaper.gif"
					 max-height="50"
					 max-width="90"
					 class="ml-5 mr-5"
					 contain />

			<v-toolbar-title class="hidden-sm-and-down mr-10">
				<strong>SIE Testbänk</strong>
			</v-toolbar-title>
			<v-toolbar-items class="hidden-sm-and-down">
				<!--<v-btn :to="'home'" text >
					  Testa fil
				 </v-btn>-->
				<v-spacer></v-spacer>
			</v-toolbar-items>
		</v-app-bar>
		<v-main>
			<home></home>
		</v-main>
		<v-footer app>
			<!-- -->
		</v-footer>
	</v-app>
</template>

<script>
	import Home from './views/Home.vue';

	export default {
		name: 'App',
		components: {
			Home
		},
		data: () => ({
		}),
		methods: {
		},
	};
</script>

<style>
</style>
